// Simple authentication handler for WebDAV
let credentials: { username: string; password: string } | null = null;

export function getAuthHeader(): string | null {
  if (!credentials) {
    const stored = sessionStorage.getItem('webdav_auth');
    if (stored) {
      credentials = JSON.parse(stored);
    }
  }
  
  if (credentials) {
    return `Basic ${btoa(`${credentials.username}:${credentials.password}`)}`;
  }
  
  return null;
}

export function setCredentials(username: string, password: string) {
  credentials = { username, password };
  sessionStorage.setItem('webdav_auth', JSON.stringify(credentials));
}

export function clearCredentials() {
  credentials = null;
  sessionStorage.removeItem('webdav_auth');
}

export function promptForCredentials(): boolean {
  const username = window.prompt('Username:');
  if (!username) return false;
  
  const password = window.prompt('Password:');
  if (!password) return false;
  
  setCredentials(username, password);
  return true;
}

export async function authenticatedFetch(
  url: RequestInfo | URL,
  init?: RequestInit
): Promise<Response> {
  const authHeader = getAuthHeader();
  const headers = new Headers(init?.headers);
  
  if (authHeader) {
    headers.set('Authorization', authHeader);
  }
  
  const response = await fetch(url, { ...init, headers });
  
  // Handle 401 Unauthorized
  if (response.status === 401) {
    clearCredentials();
    
    if (promptForCredentials()) {
      // Retry with new credentials
      const newAuthHeader = getAuthHeader();
      if (newAuthHeader) {
        headers.set('Authorization', newAuthHeader);
        return fetch(url, { ...init, headers });
      }
    }
    
    throw new Error('Authentication required');
  }
  
  return response;
}